import { IPatient } from '../interfaces'
import { Col, Form, Row } from 'antd'
import { ActionCallEmail, AvatarImg, Input, Select } from 'components/atoms'
import { SelectGender } from 'components/templates'
import { MARITAL_STATUS_OPTIONS } from 'constants/options'
import { PLACE_HOLDER_EMPTY } from 'constants/placeholder'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { formatDate, getDateOfBirthString, titleCase } from 'utils'

export const StyleContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  input {
    letter-spacing: inherit;
  }
`
export const StyleAvatarWrapper = styled.div`
  width: 20%;
  margin-top: 24px;
  .ant-form-item {
    margin-bottom: 0px;
    .ant-row {
      width: 100%;
    }
  }
`
export const StyleActionItem = styled(ActionCallEmail)`
  width: 100%;
  padding: 15px 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
`
export const StyleInforWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  .ant-form-item {
    &.span-col-5 {
      flex: 1 1 calc(20% - 16px);
      max-width: calc(20% - 16px);
    }
  }
`

export const StylePatientId = styled.div`
  text-align: center;
  font-weight: 500;
`
export const StylePatientName = styled(Form.Item)`
  font-weight: 800;
  font-size: 16px;
  color: #292d32;
  text-align: center;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  line-height: 20px;
  .ant-form-item-control-input-content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`
export const StyleFormPatientCode = styled(Form.Item)`
  height: 24px;
  line-height: 24px;
  display: flex;
  align-items: center;
  margin-top: 8px;
`

export const StyleFormAvatar = styled(Form.Item)`
  height: 100px;
  line-height: 24px;
  display: flex;
  align-items: center;
`

export const StyleActionWrapper = styled(Row)`
  list-style-type: none;
  background: #f5fbf9;
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  margin-top: 8px;
`

export const StyleColAction = styled(Col)`
  &:first-child {
    &::after {
      content: '';
      position: absolute;
      height: 35px;
      border: 1px solid rgba(60, 182, 144, 0.15);
      top: 8px;
      right: 0;
    }
  }
`

export const StyleItemField = styled.div`
  flex: 1 1 calc(25% - 15px);
  max-width: calc(25% - 15px);

  &.booking-infor {
    flex: 1 1 calc(20% - 16px);
    max-width: calc(20% - 16px);
  }

  &.span-col-5 {
    flex: 1 1 calc(20% - 16px);
    max-width: calc(20% - 16px);
  }

  &.col-span-40 {
    flex: 1 1 calc(40% - 15px);
    max-width: calc(40% - 15px);
  }

  &.panel-infor {
    flex: 1 1 calc(33% - 13px);
    max-width: calc(33% - 13px);
  }

  &.company {
    flex: 1 1 calc(50% - 15px);
    max-width: calc(50% - 15px);
  }
`

export const StyleForm = styled(Form)``

interface IProps {
  patient?: IPatient
  booking_id?: number
  onBookingIdChange?: (bookingId: number) => void
}
const ProfileInfo = (props: IProps) => {
  const { patient } = props
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const preventInput = true

  useEffect(() => {
    form.setFieldsValue({
      user_code: patient?.user_code,
      full_name: patient?.full_name,
      date_of_birth: getDateOfBirthString(
        patient?.date,
        patient?.month,
        patient?.year
      ),
      gender: patient?.gender || undefined,
      phone_number: patient?.phone_number,
      email: patient?.email,
      citizen_id: patient?.citizen_id,
      address: patient?.address,
      job: patient?.job,
      marital_status: patient?.marital_status || undefined,
      created_at: formatDate(patient?.created_at),
      guardian_name: patient?.guardian?.guardian_name || '',
      guardian_phone_number: patient?.guardian?.guardian_phone_number,
      guardian_year_birthday: patient?.guardian?.guardian_year_birthday
    })
  }, [patient])

  const NamePatientJsx = (props: { value?: string }) => {
    return <>{props?.value}</>
  }

  const PatientCodeJsx = (props: { value?: string }) => {
    return <StylePatientId>{props?.value}</StylePatientId>
  }

  const handleOnChangeFullName = (e: any) => {
    const value = e.target.value
    const valueTitle = titleCase(value)
    form.setFieldValue('full_name', valueTitle)
  }
  return (
    <StyleForm form={form}>
      <StyleContentWrapper>
        <StyleAvatarWrapper>
          <StyleFormAvatar name="full_name">
            <AvatarImg img={patient?.avatar_url} />
          </StyleFormAvatar>
          <StyleFormPatientCode name="user_code">
            <PatientCodeJsx />
          </StyleFormPatientCode>
          <StylePatientName name="full_name">
            <NamePatientJsx />
          </StylePatientName>
          <StyleActionWrapper>
            <StyleColAction span={12}>
              <Form.Item name="phone_number">
                <StyleActionItem actionType="tel">
                  <img src="./images/ic-call.svg" alt="" />
                </StyleActionItem>
              </Form.Item>
            </StyleColAction>
            <StyleColAction span={12}>
              <Form.Item name="email">
                <StyleActionItem actionType="mailto">
                  <img src="./images/ic-sms.svg" alt="" />
                </StyleActionItem>
              </Form.Item>
            </StyleColAction>
          </StyleActionWrapper>
        </StyleAvatarWrapper>
        <StyleInforWrapper>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item name="user_code">
                <Input
                  title={t('patient-code')}
                  value={patient?.user_code}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="full_name">
                <Input
                  title={t('patient-name')}
                  onChange={handleOnChangeFullName}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="date_of_birth">
                <Input
                  title={t('birthday-date')}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="gender">
                <SelectGender
                  value={patient?.gender || undefined}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="phone_number">
                <Input
                  title={t('phone-number')}
                  value={patient?.phone_number}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="email">
                <Input
                  title={t('email')}
                  value={patient?.email}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="citizen_id">
                <Input
                  title={t('citizen-identification')}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="marital_status">
                <Select
                  title={t('marital-status')}
                  preventInput={preventInput}
                  options={MARITAL_STATUS_OPTIONS}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="address">
                <Input
                  title={t('address')}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="job">
                <Input
                  title={t('job')}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="created_at">
                <Input
                  title={t('created-at')}
                  value={patient?.created_at}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Form.Item name="guardian_name">
                <Input
                  title={t('guardian-name')}
                  value={patient?.created_at}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="guardian_year_birthday">
                <Input
                  title={t('birthday')}
                  value={patient?.created_at}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="guardian_phone_number">
                <Input
                  title={t('phone-number')}
                  value={patient?.created_at}
                  preventInput={preventInput}
                  placeholder={PLACE_HOLDER_EMPTY}
                />
              </Form.Item>
            </Col>
          </Row>
        </StyleInforWrapper>
      </StyleContentWrapper>
    </StyleForm>
  )
}

export default ProfileInfo
